export default {
    getModelObra: (state) => {
        return state.obra
    },
    getObraTpl: (state) => {
        if(state.operacion==="list"){
            return "obraList"
        }
    }
}